import { render } from "./floatAd.vue?vue&type=template&id=56745232"
import script from "./floatAd.vue?vue&type=script&lang=js"
export * from "./floatAd.vue?vue&type=script&lang=js"

import "./floatAd.vue?vue&type=style&index=0&id=56745232&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__